/// <reference path="../../../../../typings/index.d.ts" />
/// <reference path="../../../components/baseClasses/dataMaintenanceSectionBase.ts" />

module Meevo.Plugins.MarketPricing {
    "use strict";

    /**
     * Schedule price Section
     */
    export class ScheduledPriceChangeSection extends Meevo.Components.BaseClasses.DataMaintenanceSectionBase<Model.DataMaintenance> {
        public disableCrud: boolean = true;
        public filter: any = {
            priceChangeStatusEnum: PriceChangeStatusEnum.Active,
            scheduleDateFrom: null,
            scheduleDateTo: null,
            //priceGroupPriceQueueId: '',
            //priceGroupEntityTypeEnum: 30556
        };
        public scheduledPriceList: Array<IPriceQueueItem>;

        public scheduledPriceEntityEnum = [
            {
                id: null,
                displayName: 'LABEL_ALL'
            },
            {
                id: PriceChangeStatusEnum.Active,
                displayName: 'LABEL_SCHEDULED'
            },
            {
                id: PriceChangeStatusEnum.Completed,
                displayName: 'LABEL_COMPLETED'
            }
        ];
        private _priceGroupEntityTypeEnum = [
            {
                id: PriceGroupEntityTypeEnum.Product,
                displayName: 'LABEL_PRODUCT'
            },
            {
                id: PriceGroupEntityTypeEnum.Service,
                displayName: 'LABEL_SERVICE'
            }
        ];
        private _priceChangeStatusEnum = [
            {
                id: PriceChangeStatusEnum.Active,
                displayName: 'LABEL_SCHEDULED'
            },
            {
                id: PriceChangeStatusEnum.Processing,
                displayName: 'LABEL_PROCESSING'
            },
            {
                id: PriceChangeStatusEnum.Completed,
                displayName: 'LABEL_COMPLETED'
            },
            {
                id: PriceChangeStatusEnum.Deleted,
                displayName: 'LABEL_DELETED'
            }
        ];

        private usageTrackingLogFn: (verbEnum: Meevo.Model.VerbEnum, payload?) => void;

        constructor(protected params: Meevo.Model.ISectionParamsMarketPrice) {

            super(params.sectionId,
                params.displayNameContentKey,
                params.template,
                params.isPrimarySection,
                params.handlesOwnCrud,
                params.baseEndpoint,
                params.sectionEndpoint,
                params.loggingService,
                params.dataService,
                params.identityService,
                params.noun,
                params.appSettings,
                params.sectionSecurityKey
            );

            this.usageTrackingLogFn = params.usageTrackingLogFn;
        }

        /**
         * Base class override which defines what a DEFAULT model looks like.
         */
        createSectionModelInstance(postAdd: (data: any) => any): void { }

        /**
         * When tab is activated
         * */
        public selected(): void {
            this.applyFilter();
        }

        public applyFilter(): void {
            this.scheduledPriceList = [];

            this.params.busyService.start();
            this.dataService.customMethodData(`${this.appSettings.API_ROOT}/PriceManagement/Queue/List`, 'POST', this.filter).then(res => {
                this.scheduledPriceList = res.data.map((e: IPriceQueueItem) => {
                    let entry: IPriceQueueItem = e;

                    entry.date = e.scheduleDate;
                    entry.type = this.generateName(this._priceGroupEntityTypeEnum, e.priceGroupEntityTypeEnum);
                    entry.status = this.generateName(this._priceChangeStatusEnum, e.priceChangeStatusEnum);
                    entry.editable = e.priceChangeStatusEnum === PriceChangeStatusEnum.Active;
                    return entry;
                });

                this.params.busyService.stop();
            });
        }

        private generateName($transArr, $el): string {
            let obj = _.find($transArr, (el: any) => {
                return el.id === $el;
            });
            
            return this.params.$translate.instant(obj.displayName);
        }

        public deletePriceChange(item: IPriceQueueItem): void {
            this.params.modalService.confirmHandler('MESSAGE_DELETE_CONFIRMATION_PRICE_CHANGE').then((res: boolean) => {
                if (res === true) {
                    this.dataService.customMethodData(`${this.appSettings.API_ROOT}/PriceManagement/Queue/${item.priceGroupEntityTypeEnum}/${item.priceGroupPriceQueueId}`, 'DELETE', null).then(res => {
                        this.applyFilter();
                    });
                }
            });
        }

        public editPriceChange(item: IPriceQueueItem): void {
            if (!item) return;

            let data = {
                priceQueueItem: item,
            };
            this.params.contextService.setVisualState(Model.MaintenanceFormVisualState.CustomSchedulePrice, data);
        }

        public schedulePriceChange(): void {
            this.params.contextService.setVisualState(Model.MaintenanceFormVisualState.CustomSchedulePrice);
        }
    }
}